import { useEffect, useState, useCallback } from 'react';
import NavComponent from '../../../components/common/NavComponent';
import Pagination from '../../../components/common/Pagination';
import { useDialog } from '../../../dialog/DialogProvider';
import TwoButtonAlertDialog from '../../../dialog/TwoButtonAlertDialog';
import useMember from '../../../hooks/useMember';
import CommTab from '../CommTab';
import './List_VillageManagePage.scss';
import VillageMngAPI from '../../../apis/VillageMngAPI';
import VillageMngInfo from '../../../models/VillageMngInfo';
import noList from '../../../assets/noList.png';
import OneButtonAlertDialog from '../../../dialog/OneButtonAlertDialog';
import TimeUtil from '../../../utils/TimeUtil';

const ListVillageManagePage = () => {

  type SearchField = 'nickname' | 'username' | 'both';

  const [keyword, setKeyword] = useState('');
  const [searchField, setSearchField] = useState<SearchField>('nickname');

  const tcUid = sessionStorage.getItem('town');
  const { member } = useMember();
  const { showDialog } = useDialog();

  const [page, setPage] = useState<number>(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [generalRoles, setGeneralRoles] = useState(false);
  const [managerRoles, setManagerRoles] = useState(false);
  const [subManagerRoles, setSubManagerRoles] = useState(false);
  const [smtCount, setSmtCount] = useState<number>(0);
  const [abrCount, setAbrCount] = useState<number>(0);
  const [mbrCount, setMbrCount] = useState<number>(0);
  const [villageManageList, setVillageManageList] = useState<VillageMngInfo>();

  const fetchList = useCallback(
    async (pageNo: number = page, kw: string = keyword, field: SearchField = searchField ) => {
      const params: any = { page: pageNo - 1, size: 10 };
      if (tcUid) params.tcUid = Number(tcUid);
      const q = kw.trim();
      if (q) {
        if (field === 'nickname'){
          params.nickname = q;
        }else if (field === 'username'){
          params.username = q;
        }else {
          params.nickname = q;
          params.username = q;
        }
      }

      const res = await VillageMngAPI.getMngList(params);

      setVillageManageList(res);
      setTotalCount(Number(res.totalElements));
      setSmtCount(res.roleCounts?.SMT || 0);
      setAbrCount(res.roleCounts?.ABR || 0);
      setMbrCount(res.roleCounts?.MBR || 0);

      // 현재 페이지가 비어있으면 한 페이지 앞으로
      if (pageNo > 1 && (!res.content || res.content.length === 0)) {
        setPage(pageNo - 1);
      }
    },
    [page, tcUid, keyword, searchField ]
  );

  useEffect(() => {
    fetchList(page);
  }, [fetchList, page, tcUid, keyword, searchField]);

  const afterSuccess = async () => {
    await fetchList(page);
	await TimeUtil.delay(220);
    showDialog(OneButtonAlertDialog, {
      title: '주민 관리',
      message: '권한을 변경하였습니다.',
    });
};

  // 권한 검사
  useEffect(() => {
    if (!member) return;
    if (member.roles === 'AMN') {
      setGeneralRoles(true);
    } else if (member.roles === 'MST') {
      if (member.townDTO.townId === Number(tcUid)) {
        setManagerRoles(true);
      }
    } else if (member.roles === 'SMT') {
      setSubManagerRoles(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [member, tcUid]);

  const actionMap: Record<
    string,
    { roles: string; g: boolean; successMsg?: string }
  > = {
    asgnmMST: { roles: 'MST', g: true },   // 운영자 양도
    appointedMST: { roles: 'MST', g: false }, // 운영자 지정
    clearMST: { roles: 'SMT', g: false },  // 운영자 해제 → 부운영자?
    appointedSMT: { roles: 'SMT', g: false }, // 부운영자 지정
    clearSMT: { roles: 'ABR', g: false },  // 부운영자 해제 → 활동가?
    appointedABR: { roles: 'ABR', g: false }, // 활동가 지정
    clearABR: { roles: 'MBR', g: false },  // 활동가 해제 → 주민
  };

  // 관리 버튼
  const handleManagementButton = (
    message: string,
    action: string,
    nickname: string
  ) => {
    showDialog(TwoButtonAlertDialog, {
      title: '',
      message,
      action: 'ok',
      handleDialogResult(result) {
        if (result !== '확인') return;

        const map = actionMap[action];
        if (!map) return;

        VillageMngAPI.updateRoles({
          nickname: String(nickname),
          g: map.g,
          roles: map.roles,
        })
          .then(afterSuccess)
          .catch(() =>
            showDialog(OneButtonAlertDialog, {
              title: '오류',
              message: '권한 변경에 실패했습니다. 다시 시도해주세요.',
            })
          );
      },
    });
  };
      const onSearch = (value: string) => {
      setKeyword(value);
      setPage(1);
    };

    const onSearchClick = () => fetchList(1, keyword, searchField);
    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') onSearchClick();
    };


  const handlePageChange = (p: number) => setPage(p);

  const nullListMessage = '해당 마을의 주민이 없습니다.';

  return (
    <main className="List_VillageManagePage">
      <h1 className="notext">전체 영역</h1>
      <NavComponent />
      			{/* 검색 영역 */}
            <div className="comm_search mt40" >
              <ul>
                <li>
                  {/* 검색 대상(닉네임/실명/둘다) */}
                  <select
                    className="comm_select03"
                    value={searchField}
                    onChange={(e) => setSearchField(e.target.value as SearchField)}
                  >
                    <option value="nickname">닉네임</option>
                    <option value="username">실명</option>
                    {/* <option value="both">둘 다</option> */}
                  </select>

                  <div className="comm_search_plus">
                    <input
                      type="text"
                      placeholder={
                        searchField === 'username'
                          ? '실명을 입력해주세요.'
                          : searchField === 'nickname'
                          ? '닉네임을 입력해주세요.'
                          : '닉네임/실명을 입력해주세요.'
                      }
                      value={keyword}
                      onChange={(e) => onSearch(e.target.value)}
                      onKeyDown={onKeyDown}
                    />
                  </div>

                  <button type="button" onClick={onSearchClick}>
                    검색
                  </button>
                </li>
              </ul>
            </div>
      <article id="container">
        <h2 className="notext">컨텐츠 영역</h2>
        <div id="content">
          <CommTab clickTab={6} />
          {villageManageList ? (
            <>
              <div className="village_manage mt40">
                <div className="manage_number mb25">
                  <p>
                    부운영자 <span>{smtCount}명</span>, 마을활동가{' '}
                    <span>{abrCount}명</span>, 마을주민 <span>{mbrCount}명</span>
                  </p>
                </div>
                <div className="cont_content manage_table">
                  <ul className="thead pa20">
                    <li>권한</li>
                    <li>닉네임</li>
                    <li>실명</li>
                    <li>가입날짜</li>
                    <li>관리</li>
                  </ul>
                  <ul className="tbody">
                    {villageManageList?.content?.map((list, index) => (
                      <li className="pa20" key={index}>
                        <p className="power">
                          {list.roles === 'MST'
                            ? '운영자'
                            : list.roles === 'SMT'
                            ? '부운영자'
                            : list.roles === 'ABR'
                            ? '마을 활동가'
                            : list.roles === 'MBR'
                            ? '마을 주민'
                            : list.roles === 'AMN'
                            ? '총괄 관리자'
                            : '권한 없음'}
                        </p>
                        <p className="comm_title">{list.nickname}</p>
                        <p className="comm_title">
                          {list.username?.trim() || '실명 미입력'}
                        </p>
                        <p>{list.crtDt}</p>
                        <p>
                          {generalRoles && (
                            <>
                              {list.roles === 'MST' && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleManagementButton(
                                      '운영자 권한을 해제하시겠습니까?',
                                      'clearMST',
                                      String(list?.nickname)
                                    )
                                  }
                                >
                                  운영자 해제
                                </button>
                              )}
                              {list.roles === 'SMT' && (
                                <>
                                  <button
                                    type="button"
                                    className="btn_blue"
                                    onClick={() =>
                                      handleManagementButton(
                                        '운영자 권한을 지정하시겠습니까?',
                                        'appointedMST',
                                        String(list?.nickname)
                                      )
                                    }
                                  >
                                    운영자 지정
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleManagementButton(
                                        '부운영자 권한을 해제하시겠습니까?',
                                        'clearSMT',
                                        String(list?.nickname)
                                      )
                                    }
                                  >
                                    부운영자 해제
                                  </button>
                                </>
                              )}
                              {list.roles === 'ABR' && (
                                <>
                                  <button
                                    type="button"
                                    className="btn_blue"
                                    onClick={() =>
                                      handleManagementButton(
                                        '부운영자 권한을 지정하시겠습니까?',
                                        'appointedSMT',
                                        String(list?.nickname)
                                      )
                                    }
                                  >
                                    부운영자 지정
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleManagementButton(
                                        '활동가 권한을 해제하시겠습니까?',
                                        'clearABR',
                                        String(list?.nickname)
                                      )
                                    }
                                  >
                                    활동가 해제
                                  </button>
                                </>
                              )}
                              {list.roles === 'MBR' && (
                                <button
                                  type="button"
                                  className="btn_blue"
                                  onClick={() =>
                                    handleManagementButton(
                                      '활동가 권한을 지정하시겠습니까?',
                                      'appointedABR',
                                      String(list?.nickname)
                                    )
                                  }
                                >
                                  활동가 지정
                                </button>
                              )}
                            </>
                          )}

                          {managerRoles && (
                            <>
                              {list.roles === 'SMT' && (
                                <>
                                  <button
                                    type="button"
                                    className="btn_blue"
                                    onClick={() =>
                                      handleManagementButton(
                                        '운영자 권한을 양도하시겠습니까?',
                                        'asgnmMST',
                                        String(list?.nickname)
                                      )
                                    }
                                  >
                                    운영자 양도
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleManagementButton(
                                        '부운영자 권한을 해제하시겠습니까?',
                                        'clearSMT',
                                        String(list?.nickname)
                                      )
                                    }
                                  >
                                    부운영자 해제
                                  </button>
                                </>
                              )}
                              {list.roles === 'ABR' && (
                                <>
                                  <button
                                    type="button"
                                    className="btn_blue"
                                    onClick={() =>
                                      handleManagementButton(
                                        '부운영자 권한을 지정하시겠습니까?',
                                        'appointedSMT',
                                        String(list?.nickname)
                                      )
                                    }
                                  >
                                    부운영자 지정
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleManagementButton(
                                        '활동가 권한을 해제하시겠습니까?',
                                        'clearABR',
                                        String(list?.nickname)
                                      )
                                    }
                                  >
                                    활동가 해제
                                  </button>
                                </>
                              )}
                              {list.roles === 'MBR' && (
                                <button
                                  type="button"
                                  className="btn_blue"
                                  onClick={() =>
                                    handleManagementButton(
                                      '활동가 권한을 지정하시겠습니까?',
                                      'appointedABR',
                                      String(list?.nickname)
                                    )
                                  }
                                >
                                  활동가 지정
                                </button>
                              )}
                            </>
                          )}

                          {subManagerRoles && (
                            <>
                              {list.roles === 'ABR' && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleManagementButton(
                                      '활동가 권한을 해제하시겠습니까?',
                                      'clearABR',
                                      String(list?.nickname)
                                    )
                                  }
                                >
                                  활동가 해제
                                </button>
                              )}
                              {list.roles === 'MBR' && (
                                <button
                                  type="button"
                                  className="btn_blue"
                                  onClick={() =>
                                    handleManagementButton(
                                      '활동가 권한을 지정하시겠습니까?',
                                      'appointedABR',
                                      String(list?.nickname)
                                    )
                                  }
                                >
                                  활동가 지정
                                </button>
                              )}
                            </>
                          )}
                        </p>
                      </li>
                    ))}
                  </ul>
                  <Pagination
                    page={Number(page)}
                    totalPageCount={Math.ceil(totalCount / 10)}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="comm_noList">
                <img src={noList} alt="내용없음 이미지" />
                <p className="mt25">{nullListMessage}</p>
              </div>
            </>
          )}
        </div>
      </article>
    </main>
  );
};

export default ListVillageManagePage;
